import React, { useState } from "react";
import BackgroundImage from "../assets/steelhaus-Pillar.webp";
import Pistols from "../assets/Pistols.png";
import SteelhausLogo from "../assets/Steelhaus.webp";
import { NavBar } from "./NavBar";
import Logo from "../assets/simbol-Pillar.webp";
import ContactLogo from "../assets/logo-Pillar.webp";
import { Modal } from "antd";
import QuoteImg from "../assets/QuoteImg.webp";
import { Input } from "antd";

export function PresentationSection({ onOpenModal }) {
  const [videoModalOpen, setVideoModalOpen] = useState(false);

  const handleOpenVideoModal = () => {
    setVideoModalOpen(true);
  };

  const handleCloseVideoModal = () => {
    setVideoModalOpen(false);
  };

  return (
    <>
      <section
        className="presentationSection"
        style={{ position: "relative", overflow: "hidden" }}>
        <div className="presentationSectionOverlay">
          <h2 className="mainHeadline whiteText">
            Please review
            <span className="yellowTextHighlight"> our video</span> presentation
            of our starter packs.
          </h2>
          <button className="yellowBtn" onClick={handleOpenVideoModal}>
            Video Presentation
          </button>
        </div>
      </section>
      <Modal
        open={videoModalOpen}
        onCancel={handleCloseVideoModal}
        onOk={handleCloseVideoModal}
        width="1182px"
        footer={false}
        style={{
          position: "absolute",
          right: "0",
          left: "0",
          overflow: "hidden",
        }}>
        <div className="presentationVideoMain">
          <iframe
            width="1082"
            height="609"
            src="https://www.youtube.com/embed/eJ4Wdhl03cI?si=yLpVzZnEwG4PNPsU&amp;controls=0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen></iframe>
        </div>
      </Modal>
    </>
  );
}
